export default "__VITE_ASSET__30b8b47c__"